const LINKS = {
  PERSONAL_DATA: 'https://sejfa.nu/personuppgifter/',
  COOKIES: 'https://sejfa.nu/cookies/',
  TERMS_AND_CONDITIONS: 'https://sejfa.nu/anvandarvillkor/',
  YOUR_INTEGRITY: 'https://sejfa.nu/din-integritet/'
};
export default LINKS;
